import {Checkbox} from '~/components/checkbox'
import {Layout} from '~/components/layout'
import {Text} from '~/components/text'
import {HeaderTitle} from './title'
import {getMultiActionRowState} from '~/components/advanced_table/helpers'
import {useMultiActionContext} from '~/components/multi_action/context/multi_action_context'

export const HeaderWithCheckbox = ({Element, elementProps = {}, aggregates, multiAction, ...rest}) => {
	if (!Element) {
		elementProps = {value: rest.header.id, context: rest.header.getContext(), ...rest}
		Element = HeaderTitle
	}

	return (
		<Layout vertical="center">
			<HeaderCheckbox table={rest.table} multiAction={multiAction} getRowDisabled={rest.getRowDisabled} />
			<Layout direction="vertical" gap={0}>
				<Element {...rest} {...elementProps} />
				<Text semiBold fontSize={8}>
					{aggregates}
				</Text>
			</Layout>
		</Layout>
	)
}

const HeaderCheckbox = ({table, multiAction, getRowDisabled}) => {
	const {multiActionIds, setMultiActionActive, toggleMultiActionIds} = useMultiActionContext()
	const getRowCanUseMultiAction = row => {
		if (getRowDisabled?.(row)) return false
		return multiAction.getRowIsEditable ? multiAction.getRowIsEditable(row) : true
	}

	const rows = table.getRowModel().flatRows.filter(row => !row.getIsGrouped())
	const {disabled, checked, indeterminate, editableRowIds} = getMultiActionRowState(rows, getRowCanUseMultiAction, multiActionIds)

	const handleChange = () => {
		if (disabled) return

		setMultiActionActive(true)
		toggleMultiActionIds(editableRowIds)
	}
	const handleKeyDown = event => {
		if (event.key === ' ' || event.key === 'Enter') event.stopPropagation()
	}

	return (
		<Checkbox
			disabled={disabled}
			checked={indeterminate ? 'indeterminate' : checked}
			onChange={handleChange}
			onKeyDown={handleKeyDown}
			onClick={e => e.stopPropagation()}
		/>
	)
}
